@use '@lib/assets/styles/main.scss' as *;

$imageSize: 76px;

.root {
  display: grid;
  grid-template-columns: $imageSize auto;
  grid-column-gap: 24px;
  align-items: center;
}

.img {
  img, svg {
    display: block;
    width: 100%;
    height: auto;
  }
  img {
    object-fit: cover;
    width: $imageSize;
    height: $imageSize;
    border-radius: 4px;
    border: 1px solid $gray200;
  }
}

.actions {
  display: flex;
  gap: 16px;
}

.icons {
  padding: 8px 0;
  border-radius: 8px;
  border: 1px solid $gray100;
  background: $gray10;
  margin-bottom: 32px;
}

.iconsScroll {
  @include scrollStyles;
  overflow-y: auto;
  overflow-x: hidden;
  height: 324px;
  padding: 0 8px;
}

.iconsGrid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 8px;
}

.icon {
  width: 76px;
  height: 76px;
  border-radius: 4px;
  border: 1px solid $gray200;
  background: $blue20;
  box-shadow: 0 0 0 inset;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    display: block;
  }
  &:hover {
    border-color: $blue500;
  }
  &.iconSelected {
    border-color: $blue500;
    box-shadow: 0 0 2px $blue500 inset;
  }
}

.blockIcon {
  color: $gray400;
}
